import moment from "moment";
import { appConfig } from "../../configs";
import { IViewTransactionChartDto } from "../../interfaces-and-types";
import {
  convertMapToArray,
  groupByKeyAndSumByValue,
  groupByKeyAndSumByValueMulti,
  insertDaysDataPoints,
  insertTodayDataPoints,
  mapToXY,
} from "../../utils";

export const todayGrossVolumeChartXYFormatter = (
  todaysTransactions: IViewTransactionChartDto[]
) => {
  return (
    todaysTransactions &&
    insertTodayDataPoints(
      mapToXY(
        convertMapToArray(
          groupByKeyAndSumByValue(
            todaysTransactions,
            (tx) =>
              moment(tx.created_at).minute(0).format(appConfig.timeFormat1),
            (tx) => tx.amount
          )
        ),
        (item) => item.key, // moment(item.key).format(appConfig.timeFormat1),
        (item) => item.value
      ),
      {
        x: moment(new Date().setHours(0, 0, 0, 0)).format(
          appConfig.timeFormat1
        ),
        y: 0,
      },
      {
        x: moment(new Date().setHours(23, 59, 59, 50)).format(
          appConfig.timeFormat1
        ),
        y: 0,
      },
      appConfig.timeFormat1,
      {
        x: new Date(),
        y: 0,
      },
      {
        x: new Date(),
        y: null,
      },
      false //true
    )
  );
};

export const totalSalesChartFormatter = (
  transactionsByPeriod: IViewTransactionChartDto[],
  startChartPeriod: string,
  endChartPeriod: string
) => {
  return (
    transactionsByPeriod &&
    insertDaysDataPoints(
      mapToXY(
        convertMapToArray(
          groupByKeyAndSumByValue(
            transactionsByPeriod,
            (tx) => moment(tx.created_at).format(appConfig.dateFormat1),
            (tx) => tx.amount
          )
        ),
        (item) => new Date(item.key),
        (item) => item.value
      ),
      {
        x: new Date(startChartPeriod),
        y: 0,
      },
      {
        x: new Date(endChartPeriod),
        y: 0,
      },
      appConfig.dateFormat1,
      {
        x: new Date(endChartPeriod),
        y: 0,
      }
    )
  );
};

export const transactionsByCustomerByPeriodChartFormatter = (
  transactionsByPeriod: { customer_id: string; created_at: string }[],
  startChartPeriod: string,
  endChartPeriod: string
) => {
  return (
    transactionsByPeriod &&
    insertDaysDataPoints(
      mapToXY(
        convertMapToArray(
          groupByKeyAndSumByValueMulti(
            transactionsByPeriod,
            (tx) => [
              moment(tx.created_at).format(appConfig.dateFormat1),
              tx.customer_id,
            ],
            (tx) => 1
          )
        ),
        (item) => new Date(item.key),
        (item) => item.value
      ),
      {
        x: new Date(startChartPeriod),
        y: 0,
      },
      {
        x: new Date(endChartPeriod),
        y: 0,
      },
      appConfig.dateFormat1,
      {
        x: new Date(endChartPeriod),
        y: 0,
      }
    )
  );
};

export const chartXYFormatter = (
  dataByPeriod: { count: number; created_at: string }[],
  startChartPeriod: string,
  endChartPeriod: string
) => {
  return (
    dataByPeriod &&
    insertDaysDataPoints(
      mapToXY(
        convertMapToArray(
          groupByKeyAndSumByValue(
            dataByPeriod,
            (tx) => moment(tx.created_at).format(appConfig.dateFormat1),
            (tx) => tx.count // we don't care about the value, we just want to count the transactions
          )
        ),
        (item) => new Date(item.key),
        (item) => item.value
      ),
      {
        x: new Date(startChartPeriod),
        y: 0,
      },
      {
        x: new Date(endChartPeriod),
        y: 0,
      },
      appConfig.dateFormat1,
      {
        x: new Date(endChartPeriod),
        y: 0,
      }
    )
  );
};

export const interpolateEmptyValues = (data: any[]) => {
  const result = [];
  let lastValue = data[0];
  for (let i = 0; i < data.length; i++) {
    if (data[i] === null) {
      result.push(lastValue);
    } else {
      lastValue = data[i];
      result.push(lastValue);
    }
  }
  return result;
};

export const interpolateEmptyDates = (data: any[]) => {
  const result = [];
  let lastValue = data[0];
  for (let i = 0; i < data.length; i++) {
    if (data[i] === null) {
      result.push(lastValue);
    } else {
      lastValue = data[i];
      result.push(lastValue);
    }
  }
  return result;
};
